import React from "react";
import { useNavigate } from "react-router-dom";

function formatDateOnly(value) {
  if (!value) return "";
  return String(value).slice(0, 10);
}

export default function InventoryLedgerTable({ rows = [] }) {

const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
      <div className="px-4 py-3 border-b">
        <h3 className="font-semibold">Inventory Ledger</h3>
      </div>

      <div className="overflow-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="text-left px-4 py-3">Date</th>
              <th className="text-left px-4 py-3">Document</th>
              <th className="text-left px-4 py-3">Movement</th>
              <th className="text-right px-4 py-3">Qty In</th>
              <th className="text-right px-4 py-3">Qty Out</th>
              <th className="text-right px-4 py-3">Unit Cost</th>
              <th className="text-right px-4 py-3">Amount</th>
              <th className="text-left px-4 py-3">Currency</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((row) => (
                <tr key={row.id} className="border-t">
                  <td className="px-4 py-3">{formatDateOnly(row.posting_date)}</td>
                  <td>
  <button
    onClick={() => navigate(`/erp/documents/${row.doc_header_id}`)}
    className="text-left hover:underline"
  >
    <div className="flex flex-col">
      <span className="font-medium">
        {row.doc_no || row.doc_header_id}
      </span>
      <span className="text-xs text-slate-500">
        {row.doc_type}
      </span>
    </div>
  </button>
</td>
                  <td>
  <span
    className={
      row.movement_type === "RECEIPT"
        ? "text-green-600"
        : row.movement_type === "ISSUE"
        ? "text-red-600"
        : "text-blue-600"
    }
  >
    {row.movement_type}
  </span>
</td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.qty_in || 0).toFixed(4)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.qty_out || 0).toFixed(4)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.unit_cost || 0).toFixed(4)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.amount || 0).toFixed(4)}
                  </td>
                  <td className="px-4 py-3">{row.currency || ""}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="px-4 py-6 text-center text-slate-500">
                  No ledger rows found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}